import { Golem } from "./golem";
export class BlueGolem extends Golem {
    constructor() {
        super(...arguments);
        this.cooldown = 9000;
    }
}
BlueGolem.displayName = "Blue Golem";
BlueGolem.artUrl = "./assets/cards/bluegolem.jpg";
BlueGolem.effect = {
    callback: () => { },
    description: "Consume a Rock and play a card every nine seconds",
    needsFeedback: true,
};
